import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const PerfilList = props => <DefaultDataTable data={props} />;
